import {
  type UseSuspenseQueryResult,
  useSuspenseQuery,
} from '@tanstack/react-query';
import api from '@/axios';
import { GET_LOT_SIZING_CRITERIA_KEY } from '@/keys';
import type { LotSizingCriteria } from '@/types/core/lot-sizing/lot-sizing-criteria';

export const getLotSizingCriteria = async (
  lotSizingId: string,
): Promise<LotSizingCriteria> => {
  const response = await api.get<LotSizingCriteria>(
    `/lot-sizings/${lotSizingId}/criteria`,
  );
  return response.data;
};

export const useGetLotSizingCriteria = (
  lotSizingId: string,
): UseSuspenseQueryResult<LotSizingCriteria, Error> =>
  useSuspenseQuery({
    queryKey: [...GET_LOT_SIZING_CRITERIA_KEY, lotSizingId],
    queryFn: () => getLotSizingCriteria(lotSizingId),
  });
